import Box from "@memorang/ui/src/components/Box";
import { Fragment } from "react";
import { Divider } from "react-native-paper";
import type { MixedItemTag } from "types/tag";
import TopicListHeader from "./TopicListHeader";
import TopicListItem from "./TopicListItem";
import type { SortByDataType, SortOrderType } from "./types";

type TopicViewMainContentProps = {
	onSortPress: () => void;
	tags: MixedItemTag[];
	selectedSortByItem?: SortByDataType;
	selectedSortOrder: SortOrderType;
	title: string;
};

const TopicViewMainContent = ({
	onSortPress,
	tags,
	selectedSortByItem,
	selectedSortOrder,
	title,
}: TopicViewMainContentProps) => {
	const numTags = tags.length;
	return (
		<Box>
			<TopicListHeader
				title={title}
				onSortPress={onSortPress}
				numTags={numTags}
				selectedSortByItem={selectedSortByItem}
				selectedSortOrder={selectedSortOrder}
			/>
			<Box flexGrow={1}>
				{tags.map((tag, index) => (
					<Fragment key={`${tag.id}-${index}`}>
						<TopicListItem
							{...tag}
							numItems={tag.numItems}
							title={
								tag.code
									? `${tag.code} - ${tag.label || tag.title || ""}`
									: tag.label || tag.title || ""
							}
						/>
						{index !== tags.length - 1 && <Divider />}
					</Fragment>
				))}
			</Box>
		</Box>
	);
};

export default TopicViewMainContent;
